// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v6.30.2
// source: tickets.proto

/* eslint-disable */
import type { Conversation } from "./data_import";
import type { FilteredTicketOptionValue, FilterValueRequest, TicketSearchFilterRequest } from "./filters";
import type { Empty } from "./google/protobuf/empty";

export const protobufPackage = "proto";

export enum StatisticalDistributionPeriod {
  LAST_7_DAYS = "LAST_7_DAYS",
  LAST_WEEK = "LAST_WEEK",
  LAST_30_DAYS = "LAST_30_DAYS",
  LAST_MONTH = "LAST_MONTH",
}

export enum StatisticalDistributionCategory {
  ROOT = "ROOT",
  CONNECTION = "CONNECTION",
  LANGUAGE = "LANGUAGE",
  CHANNEL = "CHANNEL",
  CSAT = "CSAT",
  COMPLEXITY = "COMPLEXITY",
  SENTIMENT = "SENTIMENT",
  REVIEWED = "REVIEWED",
  AGENT_PERFORMANCE = "AGENT_PERFORMANCE",
  AGENT_SENTIMENT = "AGENT_SENTIMENT",
  AGENT_CSAT = "AGENT_CSAT",
  AGENT_REVIEWED = "AGENT_REVIEWED",
}

export enum AutoInsightType {
  CHURN_RISK = "CHURN_RISK",
  FOLLOW_UP = "FOLLOW_UP",
  ESCALATION = "ESCALATION",
  EXTRA_MILE = "EXTRA_MILE",
  OUTLIER = "OUTLIER",
  NEGATIVE_SENTIMENT = "NEGATIVE_SENTIMENT",
  POSITIVE_SENTIMENT = "POSITIVE_SENTIMENT",
  DEADAIR_EXCEEDED = "DEADAIR_EXCEEDED",
  SLA_BREACHED = "SLA_BREACHED",
  RECORDING_DISCLOSURE_MISSING = "RECORDING_DISCLOSURE_MISSING",
  NEGATIVE_BOT_COMMUNICATION_EFFICIENCY = "NEGATIVE_BOT_COMMUNICATION_EFFICIENCY",
  POSITIVE_BOT_COMMUNICATION_EFFICIENCY = "POSITIVE_BOT_COMMUNICATION_EFFICIENCY",
  BOT_REPETITION = "BOT_REPETITION",
  CUSTOM_PHRASE_SEARCH = "CUSTOM_PHRASE_SEARCH",
  PROMPT = "PROMPT",
}

export interface DynamicOptionResponse {
  channels: FilteredTicketOptionValue[];
  satisfactionScores: FilteredTicketOptionValue[];
}

export interface TicketExternalIDRequest {
  connectionId: string;
  workspaceID: string;
  externalId: string;
}

export interface GetTicketConditionsRequest {
  connectionID: string;
  externalTicketID?: string | undefined;
}

export interface GetSurveysRequest {
  connectionId: string;
  externalId: string;
  language?: string | undefined;
}

export interface TicketExternalIDTranslationRequest {
  connectionId: string;
  externalId: string;
  /** ISO-639 code from: https://cloud.google.com/translate/docs/languages */
  language: string;
}

export interface TagsSearchRequest {
  tag: string;
  limit: number;
}

export interface TagsSearchResponse {
  tags: string[];
  total: number;
}

export interface TicketMessagesSentimentResponse {
  messageSentiment: TicketMessageSentiment[];
}

export interface TicketMessagesTranslationResponse {
  body: { [key: string]: TicketMessageBodyEntry };
}

export interface TicketMessagesTranslationResponse_BodyEntry {
  key: string;
  value: TicketMessageBodyEntry | undefined;
}

export interface TicketMessageBodyEntry {
  body: string;
}

export interface UsersStatisticalDistributionRequest {
  period: StatisticalDistributionPeriod;
  categories: StatisticalDistributionCategory[];
  filters: StatisticalDistributionFilter[];
}

export interface UsersStatisticalDistributionResponse {
  data: StatisticalDistribution | undefined;
}

export interface TicketStatisticalDistributionRequest {
  period: StatisticalDistributionPeriod;
  categories: StatisticalDistributionCategory[];
  filters: StatisticalDistributionFilter[];
}

export interface TicketStatisticalDistributionResponse {
  data: StatisticalDistribution | undefined;
}

export interface StatisticalDistribution {
  name: string;
  value: string;
  category: StatisticalDistributionCategory;
  size: string;
  children: StatisticalDistribution[];
}

export interface TicketMessageSentiment {
  externalId: string;
  sentiment: string;
}

export interface GetTicketExistsRequest {
  accountId: string;
  workspaceId: string;
  connectionId: string;
  conversationExternalId: string;
}

export interface TicketSearchRequest {
  workspaceId: string;
  offset: string;
  limit: string;
  userId: string;
  filterId: string | undefined;
  sort: string | undefined;
  accountId: string;
  workspaceConnectionIds: string[];
  replyCount: string | undefined;
  replyCountCondition: string | undefined;
  sourceTypeList: string[];
  sourceTypeCondition: string | undefined;
  ticketGroupList: string[];
  ticketGroupCondition: string | undefined;
  ticketBrandList: string[];
  ticketBrandCondition: string | undefined;
  ticketFormList: string[];
  ticketFormCondition: string | undefined;
  ticketNumberList: string[];
  ticketNumberCondition: string | undefined;
  ticketMailboxList: string[];
  ticketMailboxCondition: string | undefined;
  ticketFolderList: string[];
  ticketFolderCondition: string | undefined;
  lastReplyFrom: string | undefined;
  lastReplyTo: string | undefined;
  ticketChannel: TicketConditionList | undefined;
  commentChannelList: string[];
  commentChannelCondition: string | undefined;
  ticketViaList: string[];
  ticketViaCondition: string | undefined;
  satisfactionScore: TicketConditionList | undefined;
  surveyIdList: string[];
  surveyIdCondition: string | undefined;
  surveyQuestionIdList: string[];
  surveyQuestionIdCondition: string | undefined;
  ticketStatusList: string[];
  ticketStatusCondition: string | undefined;
  ticketTypeList: string[];
  ticketTypeCondition: string | undefined;
  ticketStateList: string[];
  ticketStateCondition: string | undefined;
  ticketPriorityList: string[];
  ticketPriorityCondition: string | undefined;
  satisfactionCommentCondition: string | undefined;
  assigneeParams: StringListSearchParam[];
  relatedParams: RelatedSearchParam[];
  commentBodyParams: TicketApiStringSearchWithNegationParam[];
  ticketTags: TicketTagSearchParam[];
  ticketSubjects: TicketApiStringSearchParam[];
  ticketDescriptions: TicketApiStringSearchParam[];
  relatedNameEmail: NameEmailSearchParam[];
  fieldParams: TicketApiTicketFieldParam[];
  callDurationParam: IntegerCompareSearchParam[];
  updated: FromToDateTimeParam[];
  created: FromToDateTimeParam[];
  reviewReceived: TicketIdListWithParameter | undefined;
  highlightStatus: TicketIdListWithParameter | undefined;
  commentStatus: TicketIdListWithParameter | undefined;
  commentedTo: TicketIdListWithParameter | undefined;
  commentedFrom: TicketIdListWithParameter | undefined;
  ratedTo: TicketIdListWithParameter | undefined;
  ratedFrom: TicketIdListWithParameter | undefined;
  ratingCategories: TicketIdListWithParameter | undefined;
  reviewedBy: TicketIdListWithParameter | undefined;
  reviewee: TicketIdListWithParameter | undefined;
  internalTags: TicketIdListWithParameter[];
  metaDataFilter: MetaParameter[];
  ticketExternalIdList: TicketIdListWithParameter | undefined;
  assigneeOrMostActiveAgent: string[];
  publicParticipantParams: StringListSearchParam[];
  disputeStatus: TicketIdListWithParameter | undefined;
  ticketExternalIdListNoConnection: TicketIdListWithParameter | undefined;
  viewed: TicketIdListWithParameter | undefined;
  reviewViewed: TicketIdListWithParameter | undefined;
  closed: FromToDateTimeParam[];
  publicMessageCount: IntegerCompareSearchParam[];
  privateMessageCount: IntegerCompareSearchParam[];
  endUserMessageCount: IntegerCompareSearchParam[];
  agentPublicMessageCount: IntegerCompareSearchParam[];
  publicWordCount: IntegerCompareSearchParam[];
  publicCharacterCount: IntegerCompareSearchParam[];
  uniqueAgentCount: IntegerCompareSearchParam[];
  spotlight: boolean | undefined;
  trash: boolean | undefined;
  language: StringListSearchParam | undefined;
  mostActiveAgentParams: StringListSearchParam | undefined;
  csatAnswered: FromToDateTimeParam[];
  endUserChannel: StringListSearchParam | undefined;
  fromType: StringListSearchParam | undefined;
  vulnerabilityHealth: boolean | undefined;
  vulnerabilityLifeEvent: boolean | undefined;
  vulnerabilityCapability: boolean | undefined;
  autoQACategory: AutoQASearchParam[];
  scorecardSearchParam: LongListSearchParam | undefined;
  ratingStatusV2: string | undefined;
  csatCreated: FromToDateTimeParam[];
  hasTranscriptionCondition: string | undefined;
  reviewCreated: FromToDateTimeParam | undefined;
  hasChurnRisk: boolean | undefined;
  hasEscalation: boolean | undefined;
  hasExtraMile: boolean | undefined;
  hasFollowUp: boolean | undefined;
  SLAParam: SLASearchParam | undefined;
  transcriptionContentParams: TicketApiStringSearchWithNegationParam[];
  hasDeadairExceeded: boolean | undefined;
  hasRecordingDisclosureMissing: boolean | undefined;
  botReplyCount: string | undefined;
  botReplyCountCondition: string | undefined;
  botType: StringListSearchParam | undefined;
  botParams: StringListSearchParam[];
  isBotEfficient: boolean | undefined;
  hasBotRepetition: boolean | undefined;
  customSpotlight: string[];
  includeRelatedReviews: boolean | undefined;
  customCategory: FilterValueRequest[];
  reviewParam: ReviewParam | undefined;
  hasCallCondition: string | undefined;
  spotlightResult: FilterValueRequest[];
}

export interface TicketConditionList {
  condition: string;
  list: string[];
  includeNulls: boolean;
}

export interface StringListSearchParam {
  stringList: string[];
  negation: boolean;
}

export interface LongListSearchParam {
  longList: string[];
  negation: boolean;
}

export interface RatingStatusParam {
  stringList: string[];
  negation: boolean;
}

export interface AutoQASearchParam {
  category: string;
  scores: AutoQASearchParam_Score[];
  negation: boolean;
}

export enum AutoQASearchParam_Score {
  NOT_FOUND = "NOT_FOUND",
  ONE = "ONE",
  TWO = "TWO",
  THREE = "THREE",
  FOUR = "FOUR",
  FIVE = "FIVE",
}

export interface RelatedSearchParam {
  stringList: string[];
  negation: boolean;
  includeAssignee: boolean;
  internalIds: string[];
}

export interface TicketApiStringSearchWithNegationParam {
  value: string;
  negation: boolean;
  prefix: string | undefined;
  suffix: string | undefined;
}

export interface TicketApiStringSearchParam {
  value: string;
  prefix: string | undefined;
  suffix: string | undefined;
}

export interface NameEmailSearchParam {
  value: TicketApiStringSearchParam | undefined;
  userExternalIds: string[];
  userExternalIdsNegation: boolean;
}

export interface TicketTagSearchParam {
  tagList: string[];
  condition: string;
}

export interface TicketApiTicketFieldParam {
  ticketFieldId: string;
  values: string[];
  condition: string;
}

export interface IntegerCompareSearchParam {
  count: string;
  condition: string;
}

export interface SLASearchParam {
  names: string[];
  condition: string;
  isNotBreached: boolean;
}

export interface FromToDateTimeParam {
  from: string | undefined;
  to: string | undefined;
}

export interface ReviewParam {
  createdFrom: string | undefined;
  createdTo: string | undefined;
  reviewedBy: ReviewUserParams | undefined;
  reviewee: ReviewUserParams | undefined;
  revieweeBotIdList: string[];
  scorecardSearchParam: LongListSearchParam | undefined;
}

export interface ReviewUserParams {
  ids: string[];
  userRemoved: boolean;
  excludeCondition: boolean;
}

export interface TicketApi {
  externalId: string;
  paymentTokenId: string;
  subject: string | undefined;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  sourceType: string;
  type: string | undefined;
  url: string | undefined;
  status: string | undefined;
  channel: string | undefined;
  assigneeId: string | undefined;
  closedAt: string | undefined;
  klausSentiment: string | undefined;
  isComplex: boolean | undefined;
  mostActiveAgentId: string | undefined;
}

export interface TicketIdListWithParameter {
  exclude: boolean;
  connectionExternalTicketIdList: ConnectionExternalTicketIdList[];
}

export interface ConnectionExternalTicketIdList {
  ticketExternalIdList: string[];
  connectionId: string;
}

export interface MetaParameter {
  key: string;
  values: string[];
  includeNulls: boolean;
  boolValue?: boolean | undefined;
}

export interface StatisticalDistributionFilter {
  category: StatisticalDistributionCategory;
  values: string[];
}

export interface StatisticalDistributionParams {
  period: StatisticalDistributionPeriod;
  agentFilters: StatisticalDistributionFilter[];
  ticketFilters: StatisticalDistributionFilter[];
}

export interface FilteredTicketListRequest {
  ticketRequest: ConnectionExternalTicketIdList[];
}

export interface TicketListRequest {
  sort: string | undefined;
  limit: string;
  offset: string;
  statisticalDistribution: StatisticalDistributionParams | undefined;
}

export interface TicketListItem {
  paymentTokenId: string;
  subject: string | undefined;
  sourceType: string;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  hasReview: boolean;
  youReviewed: boolean;
  youViewed: boolean;
  highlighted: boolean;
  url: string | undefined;
  assigneeId: string | undefined;
  assigneeName: string | undefined;
  assigneePictureUrl: string | undefined;
  channel: string | undefined;
  status: string | undefined;
  type: string | undefined;
  externalId: string;
  klausSentiment: string | undefined;
  isComplex: boolean | undefined;
}

export interface TicketListResponse {
  tickets: TicketListItem[];
}

export interface TicketCountResponse {
  count: string;
}

export interface GetTicketExistsResponse {
  exists: boolean;
}

export interface TicketField {
  externalId: string;
  name: string;
  value: string;
}

export interface TicketDataResponse {
  externalId: string;
  type?: string | undefined;
  channel?: string | undefined;
  url?: string | undefined;
  status?: string | undefined;
  state?: string | undefined;
  subject?: string | undefined;
  description?: string | undefined;
  sourceType: string;
  paymentTokenId: string;
  bodyFromIntegration: boolean;
  subjectFromIntegration: boolean;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  externalComments: ExternalComment[];
  highlighted: boolean;
  assignee: TicketAssignee | undefined;
  tags: InternalTag[];
  subDomain?: string | undefined;
  mailBoxId?: string | undefined;
  folderId?: string | undefined;
  youAreReviewee: boolean;
  metadata: TicketDataMetadata | undefined;
  customerId?: string | undefined;
  customerName?: string | undefined;
  customerEmail?: string | undefined;
  customerPhone?: string | undefined;
  youViewed: boolean;
  priority?: string | undefined;
  staleContent: boolean;
  closedAt: string | undefined;
  externalFields: TicketField[];
  externalTags: string[];
  autoInsights: TicketInsight[];
  fromAddress?: string | undefined;
  zendeskConversationId?: string | undefined;
  isIncompleteSuncoTicket?: boolean | undefined;
  brand: string | undefined;
}

export interface GetTicketConditionsResponse {
  externalId: string;
  sourceType: string;
  channel: string | undefined;
  satisfactionScore: string | undefined;
  tags: TicketTag[];
}

export interface TicketTag {
  id: string | undefined;
  value: string | undefined;
}

export interface TicketInsight {
  type: string;
  explanation: string | undefined;
  rejected: boolean | undefined;
  lastUpdatedAt: string | undefined;
  lastUpdatedBy: string | undefined;
  metadata: InsightMetadata | undefined;
  signal: string;
  detected?: boolean | undefined;
  reasoning?: string | undefined;
}

export interface InsightMetadata {
  deadAirThreshold?: string | undefined;
  deadAirs: { [key: string]: DeadAir };
  breachedSlaRule?: string | undefined;
  breachedGroupSlaRule?: string | undefined;
  botCommunicationEfficiency?: string | undefined;
  botRepetitionMessageIds: string[];
  customSpotlightName?: string | undefined;
  customSpotlightId?: string | undefined;
  customSpotlightPhrases: string[];
  customSpotlightVoiceMetadata: { [key: string]: CustomSpotlightMetadata };
  customSpotlightIsDeleted?: boolean | undefined;
}

export interface InsightMetadata_DeadAirsEntry {
  key: string;
  value: DeadAir | undefined;
}

export interface InsightMetadata_CustomSpotlightVoiceMetadataEntry {
  key: string;
  value: CustomSpotlightMetadata | undefined;
}

export interface DeadAir {
  longestDuration: string;
  transcriptionId: string;
  count: string;
  commentId: string;
}

export interface CustomSpotlightMetadata {
  transcriptionId: string;
  commentId: string;
  messageCount: string;
}

export interface AutoInsightFeedbackRequest {
  connectionId: string;
  externalTicketId: string;
  type: AutoInsightType;
  comment: string | undefined;
  rejected: boolean;
  customSpotlightId?: string | undefined;
}

export interface TicketUrlResponse {
  url: string | undefined;
  host: string | undefined;
}

export interface TicketAssignee {
  internalId: string | undefined;
  internalName: string | undefined;
  internalEmail: string | undefined;
  internalPictureUrl: string | undefined;
  externalId: string | undefined;
  externalEmail: string | undefined;
  externalName: string | undefined;
  externalPictureUrl: string | undefined;
  isInThisTeam: boolean;
}

export interface ExternalComment {
  externalId: string;
  externalTicketId: string;
  channel?: string | undefined;
  type?: string | undefined;
  fromInternalId?: string | undefined;
  fromId?: string | undefined;
  fromAddress?: string | undefined;
  fromName?: string | undefined;
  fromPictureUrl?: string | undefined;
  fromType?: string | undefined;
  toAddress?: string | undefined;
  toName?: string | undefined;
  toPictureUrl?: string | undefined;
  isPublic: boolean;
  body?: string | undefined;
  htmlBody?: string | undefined;
  createdAt: string | undefined;
  tags: InternalTag[];
  highlighted: boolean;
  madeByInternalUser: boolean;
  attachments: TicketAttachment[];
  youAreReviewee: boolean;
  recordingUrl?: string | undefined;
  customerId?: string | undefined;
  customerName?: string | undefined;
  customerEmail?: string | undefined;
  customerPhone?: string | undefined;
  callPlacedAt: string | undefined;
  callAnsweredAt: string | undefined;
  callEndedAt: string | undefined;
  callDuration?: string | undefined;
  endUser: boolean;
  fromBot: boolean;
}

export interface InternalTag {
  id: string;
  tag: string;
  userId: string | undefined;
}

export interface TicketAttachment {
  sourceType: string;
  paymentTokenId: string;
  externalId: string;
  externalCommentId: string;
  fileName?: string | undefined;
  url?: string | undefined;
  contentType?: string | undefined;
  size?: string | undefined;
}

export interface TicketDataMetadata {
  groupName?: string | undefined;
  satisfactionScore?: string | undefined;
  satisfactionComment?: string | undefined;
  externalFormName?: string | undefined;
  firstResponseTimeSeconds?: string | undefined;
  firstResolutionTimeSeconds?: string | undefined;
}

export interface TicketFieldValueSearchRequest {
  fieldValue: string;
}

export interface TicketFieldValueSearchResponse {
  data: TicketExternalIDResponse[];
}

export interface TicketExternalIDResponse {
  connectionId: string;
  externalId: string;
}

export interface GetStarredConversationsRequest {
  sort: string | undefined;
  limit: string;
  offset: string;
  assigneeId: string | undefined;
}

export interface StarConversationOrMessageRequest {
  conversationExternalId: string;
  connectionId: string;
  messageExternalId?: string | undefined;
}

export interface GetSurveysResponse {
  types: GetSurveysResponse_Type[];
}

export interface GetSurveysResponse_Response {
  answerId: string;
  createdAt: string | undefined;
  score: string;
  comment: string | undefined;
  fromName: string | undefined;
  recipientId: string | undefined;
  recipientName: string | undefined;
  recipientEmail: string | undefined;
  recipientAvatar: string | undefined;
  rawData: string;
  reason: string | undefined;
}

export interface GetSurveysResponse_Type {
  name: string;
  averageScore: string;
  responses: GetSurveysResponse_Response[];
}

export interface ConversationEventResponse {
  conversationEvent: TicketConversationEvent[];
}

export interface TicketConversationEvent {
  paymentId: string;
  paymentTokenId: string;
  externalTicketId: string;
  id: string;
  type: TicketConversationEvent_TicketEventType;
  timestamp: string | undefined;
  userId: string | undefined;
  userName: string | undefined;
  tags: string[];
  status: string | undefined;
  assigneeId: string | undefined;
  assigneeName: string | undefined;
  targetId: string | undefined;
  targetName: string | undefined;
  timeUntil: string | undefined;
  teamAssigneeId: string | undefined;
  teamAssigneeName: string | undefined;
  importedAt: string | undefined;
  macroName: string | undefined;
  externalCommentId: string | undefined;
  csatScore: string | undefined;
  csatComment: string | undefined;
}

export enum TicketConversationEvent_TicketEventType {
  UNDEFINED = "UNDEFINED",
  MACRO_USED = "MACRO_USED",
  UNSNOOZED = "UNSNOOZED",
  TAG_ADDED = "TAG_ADDED",
  SNOOZED = "SNOOZED",
  STATUS_CHANGE = "STATUS_CHANGE",
  ASSIGNEE_CHANGE = "ASSIGNEE_CHANGE",
  REDACTION = "REDACTION",
  RATING_ADDED = "RATING_ADDED",
  ASSIGNEE_REMOVED = "ASSIGNEE_REMOVED",
}

export interface HasTicketsResponse {
  exists: boolean;
}

export interface PublishedTicketSearchRequest {
  request: TicketSearchRequest | undefined;
  traceID: string;
  duration: string;
  countSearch: PublishedTicketSearchRequest_CountSearch | undefined;
}

export interface PublishedTicketSearchRequest_CountSearch {
  exact: boolean;
}

export interface SearchTicketsInternalRequest {
  request: TicketSearchRequest | undefined;
  timeoutSeconds: string;
}

export interface SearchTicketsInternalResponse {
  tickets: TicketApi[];
}

export interface GetTicketListItemsWithMetadataRequest {
  userId: string;
  workspaceId: string;
  tickets: TicketApi[];
}

export interface TicketId {
  connectionId: string;
  externalId: string;
}

export interface GetConversationParticipantsRequest {
  accountId: string;
  ticketIds: TicketId[];
}

export interface GetConversationParticipantsResponse {
  participants: GetConversationParticipantsResponse_TicketParticipants[];
}

export interface GetConversationParticipantsResponse_TicketParticipants {
  ticketId: TicketId | undefined;
  participants: string[];
}

export interface GetTicketRequest {
  accountId: string;
  connectionId: string;
  externalId: string;
}

export interface Tickets {
  HasTickets(request: Empty): Promise<HasTicketsResponse>;
  /** Search tags using query as prefix */
  SearchTicketTagsByPrefix(request: TagsSearchRequest): Promise<TagsSearchResponse>;
  /** Search tags using query as prefix over account */
  SearchAccountTicketTagsByPrefix(request: TagsSearchRequest): Promise<TagsSearchResponse>;
  GetTicketMessagesSentiment(request: TicketExternalIDRequest): Promise<TicketMessagesSentimentResponse>;
  GetTicketMessagesTranslation(request: TicketExternalIDTranslationRequest): Promise<TicketMessagesTranslationResponse>;
  SearchTickets(request: TicketSearchRequest): Promise<TicketListResponse>;
  SearchTicketsCount(request: TicketSearchRequest): Promise<TicketCountResponse>;
  GetTicketExists(request: GetTicketExistsRequest): Promise<GetTicketExistsResponse>;
  GetTicketStatisticalDistribution(
    request: TicketStatisticalDistributionRequest,
  ): Promise<TicketStatisticalDistributionResponse>;
  GetTicketList(request: TicketListRequest): Promise<TicketListResponse>;
  GetFilteredTicketList(request: FilteredTicketListRequest): Promise<TicketListResponse>;
  GetUsersStatisticalDistribution(
    request: UsersStatisticalDistributionRequest,
  ): Promise<UsersStatisticalDistributionResponse>;
  GetTicketData(request: TicketExternalIDRequest): Promise<TicketDataResponse>;
  DeleteTicket(request: TicketExternalIDRequest): Promise<Empty>;
  GetTicketUrl(request: TicketExternalIDRequest): Promise<TicketUrlResponse>;
  MarkTicketViewed(request: TicketExternalIDRequest): Promise<Empty>;
  GetTicketIDFromFieldValue(request: TicketFieldValueSearchRequest): Promise<TicketFieldValueSearchResponse>;
  GetStarredConversations(request: GetStarredConversationsRequest): Promise<TicketListResponse>;
  StarConversationOrMessage(request: StarConversationOrMessageRequest): Promise<Empty>;
  GetSurveys(request: GetSurveysRequest): Promise<GetSurveysResponse>;
  AddAutoInsightFeedback(request: AutoInsightFeedbackRequest): Promise<TicketInsight>;
  ChangeAutoInsightFeedback(request: AutoInsightFeedbackRequest): Promise<TicketInsight>;
  GetConversationEvents(request: TicketExternalIDRequest): Promise<ConversationEventResponse>;
}

export interface TicketSearchBuilder {
  GetTicketSearchRequest(request: TicketSearchFilterRequest): Promise<TicketSearchRequest>;
}

export interface TicketsInternal {
  MarkExternalTicketDeleted(request: TicketExternalIDRequest): Promise<Empty>;
  GetDynamicOptionsForAccount(request: Empty): Promise<DynamicOptionResponse>;
  SearchTicketTagsByPrefixPerAccount(request: TagsSearchRequest): Promise<TagsSearchResponse>;
  GetTicketConditions(request: GetTicketConditionsRequest): Promise<GetTicketConditionsResponse>;
  SearchTicketsInternal(request: SearchTicketsInternalRequest): Promise<SearchTicketsInternalResponse>;
  SearchTicketsCountInternal(request: SearchTicketsInternalRequest): Promise<TicketCountResponse>;
  GetTicketListItemsWithMetadata(request: GetTicketListItemsWithMetadataRequest): Promise<TicketListResponse>;
  GetConversationParticipants(
    request: GetConversationParticipantsRequest,
  ): Promise<GetConversationParticipantsResponse>;
  GetTicket(request: GetTicketRequest): Promise<Conversation>;
}
